import { CHANGE_RECORDS, RETRIEVE_RECORDS_STARTED } from '../actions/search';

export default function (state = {}, action) {
  switch (action.type) {
  case CHANGE_RECORDS: {
    const { sales, leases, meta } = action;
    return { ...state, isFetching: false, sales, leases, meta };
  }
  case RETRIEVE_RECORDS_STARTED:
    return { ...state, isFetching: true };
  default:
    return state;
  }
}
